import styled from 'styled-components'

export const ItensList = styled.div`
    border-radius: 15px;
    background-color: ${props => (props.$isDraggingOver ? '#d5f3ff' : 'transparent')};
`;